"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _style = _interopRequireDefault(require("styled-jsx/style"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _textModule = _interopRequireDefault(require("./text.module.scss"));
var _registerWidgetForDnD = require("../styles/registerWidgetForDnD");
var _kuiTypes = require("../styles/kuiTypes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var textProps = {
  variant: ["h1", "h2", "h3", "h4", "h5", "h6", "span", "p"],
  tag: ["h1", "h2", "h3", "h4", "h5", "h6", "p", "code", "span", "div", "pre"],
  align: ["left", "center", "right"],
  color: _kuiTypes.textColors,
  className: "",
  children: ""
};
var COLOR_MAP = {
  primary: "color-primary",
  accent: "color-accent",
  success: "color-success",
  danger: "color-danger",
  warning: "color-warning",
  hint: "color-hint",
  inverted: "color-inverted"
};
var VARIANT_TAG_MAP = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  span: "span",
  p: "p"
};
var Text = function Text(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? "span" : _props$variant,
    _props$align = props.align,
    align = _props$align === void 0 ? "left" : _props$align,
    _props$color = props.color,
    color = _props$color === void 0 ? "default" : _props$color,
    tag = props.tag;
  var Tag = tag || VARIANT_TAG_MAP[variant];
  return /*#__PURE__*/_react.default.createElement(Tag, {
    className: "jsx-".concat(_textModule.default.__hash) + " " + ((0, _classnames.default)("text", "align-".concat(align), COLOR_MAP[color], props.className) || "")
  }, props.children, /*#__PURE__*/_react.default.createElement(_style.default, {
    id: _textModule.default.__hash
  }, _textModule.default));
};
exports.Text = Text;
(0, _registerWidgetForDnD.registerKuiWidget)({
  name: "Text",
  component: Text,
  options: textProps,
  icon: "text_fields"
});